import { render, staticRenderFns } from "./table_config_column_import.vue?vue&type=template&id=87d14520"
import script from "./table_config_column_import.vue?vue&type=script&lang=js"
export * from "./table_config_column_import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87d14520')) {
      api.createRecord('87d14520', component.options)
    } else {
      api.reload('87d14520', component.options)
    }
    module.hot.accept("./table_config_column_import.vue?vue&type=template&id=87d14520", function () {
      api.rerender('87d14520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/metadata/table_config_column_import.vue"
export default component.exports